import { render, staticRenderFns } from "./monaco-editor-api.vue?vue&type=template&id=b8631de8"
import script from "./monaco-editor-api.vue?vue&type=script&setup=true&lang=js"
export * from "./monaco-editor-api.vue?vue&type=script&setup=true&lang=js"
import style0 from "./monaco-editor-api.vue?vue&type=style&index=0&id=b8631de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports